var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('v-col',{staticClass:"pl-1 text-caption grey--text",attrs:{"cols":"9"}},_vm._l((_vm.lines),function(line){return _c('div',[_vm._v("· "+_vm._s(line))])}),0),_vm._v(" "),_c('v-col',{attrs:{"cols":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }